export const MainGreen = '#08B273';
export const WarningRed = '#D83A68';

export const Opacity_16 = '#00000028';
export const Opacity_64 = '#000000A3';
